var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gl-border-b gl-p-4"},[_c('gl-icon',{staticClass:"gl-mr-2",attrs:{"name":"folder","variant":"subtle"}}),_vm._v(" "),_c('gl-link',{attrs:{"href":_vm.folderPath}},[_vm._v("\n    "+_vm._s(_vm.nestedEnvironment.name)+"\n    "),_c('gl-badge',{staticClass:"gl-ml-2"},[_vm._v(_vm._s(_vm.totalEnvironmentsCount))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }